import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import url from 'url';
import { Redirect } from 'react-router-dom';

import { SR_API_ACTION_GET_LISTING_BY_ID } from 'api/actionTypes';

import { SCREEN_ID_LISTING_MAP } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withLastLocation from 'client/helpers/withLastLocation';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withApiState from 'client/helpers/withApiState';

import Navbar from 'client/components/Navbar';
import SrNavbarToastButton from 'client/components/SrNavbarToastButton';
import SrOpenStreetMap from 'client/components/SrOpenStreetMap';
import ActivityIndicator from 'client/components/ActivityIndicator';
import SrLink from 'client/components/SrLink/SrLink';

import { numberWithCommas } from 'common/formatters';
import {
  getListingManagedPhotoUrls,
  getListingUrlPath,
} from 'common/listingHelpers';
import { LISTING_DATA_SOURCE_SMART_APARTMENT } from 'common/listingConstants';

import { Listing } from 'client/actions';

import branch from 'client/core/branch';

@withTransitionHook
@withScreenId(SCREEN_ID_LISTING_MAP)
@withScrollToTop
@withLastLocation
@withApiState({
  listingApiState: {
    action: SR_API_ACTION_GET_LISTING_BY_ID,
  },
})
@branch({
  listing: ['listing'],
  currentUserArea: ['currentUser', 'searchFilters', 'area'],
  appUrl: ['env', 'APP_URL'],
})
class ListingMap extends Component {
  static fetchData(match, inject) {
    return Listing.getById(inject, parseInt(match.params.listingId, 10));
  }

  static getPageMetadata = (state) => {
    const listingMeta = state.get('listing');
    const propertyTypeMeta = listingMeta.mlsNumber ? 'home' : 'apartment';
    const managedPhotoUrls = listingMeta && getListingManagedPhotoUrls({ listingMeta });
    return {
      pageTitle: listingMeta.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT
        ? (
          'Map | Sunroom Rentals'
        ) : (
          listingMeta.addressStreetDisplay + ', ' +
          listingMeta.addressCity + ', ' +
          listingMeta.addressStateCode + ' ' +
          listingMeta.addressZip + ' - Map | Sunroom Rentals'
        ),
      section: 'Listing',
      // canonical: '/',
      keywords: (
        'rent, home, apartment, austin, texas, tour, ' +
        listingMeta.addressZip + ', ' + listingMeta.addressCity
      ),
      description: (
        'Sunroom has ' + managedPhotoUrls.length +
        ' photos of this $' + numberWithCommas(listingMeta.price) + ' ' +
        propertyTypeMeta + ' with ' + listingMeta.bedrooms + ' beds ' +
        listingMeta.bathrooms + ' baths, ' + listingMeta.squareFeet + ' sqft at ' +
        listingMeta.addressStreetDisplay + ' available for move in ' +
        moment(listingMeta.availableDate).format('MMMM Do, YYYY')
      ),
      image: managedPhotoUrls[0],
    };
  }

  staticPropTypes = {
    listing: PropTypes.object.isRequired,
    listingApiState: PropTypes.object.isRequired,
    currentUserArea: PropTypes.array,
  }

  render() {
    const {
      listing,
      listingApiState,
      match,
      appUrl,
    } = this.props;

    const isSmartApartment = listing && listing.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT;

    const sunroomListingLink = listing && url.resolve(appUrl, getListingUrlPath(listing));

    if (isSmartApartment) {
      return <Redirect to={`/listing/${listing.id}`} />;
    }

    return (
      <div className='page-listing page-listing-map'>
        <div className='listing-map'>
          <Navbar
            leftButton={
              <SrLink
                className='back link'
                restoreScrollPosition
                redirectToLastLocation
                to={`/listing/${match.params.listingId}`}
              >
                Back
              </SrLink>
            }
            rightButton={(
              <SrNavbarToastButton
                toastLink={sunroomListingLink}
                toastContent='link copied!'
                buttonContent='Share'
                toggleToast
              />
            )}
          />
          <div>
            {!listing || listingApiState.inProgress
              ? <ActivityIndicator />
              : (
                <div className='mapContainer'>
                  <div className='innerMapContainer'>
                    <SrOpenStreetMap
                      coordinates={[listing.locationLongitude, listing.locationLatitude]}
                      initialZoom={13}
                    />
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ListingMap;
